export default __webpack_public_path__ + "static/media/drink.f7a66350.svg";